import { UserDataError } from '@/repositories/userDataRepository.js'

export function toUserMessage(error: unknown): string {
  if (error instanceof UserDataError) return error.message
  if (error instanceof Error && error.message) return `操作未完成：${error.message}`
  return '操作未完成，请稍后重试。'
}
